import { requestDialog } from './requestDialog';
import type { ArchiveBulkRequest } from '@mimir/web/dialogs/archiveBulkDialogRequest';

export function showArchiveBulkDialog(req: ArchiveBulkRequest) {
  requestDialog(req, () => import('@mimir/web/components/Common/Dialogs/dialogs/ArchiveBulkDialog.vue'));
}
